// extracted by mini-css-extract-plugin
module.exports = {"Section1JP":"Section1JP_Section1JP__04FK5"};